'use client';

import {
  TBillingConfig,
  TMembershipContext,
  TMembershipType,
} from '@/model/configuration';
import { createContext, ReactNode, useState } from 'react';

type TOwnProps = {
  children?: ReactNode;
};

export const MembershipTypeContext = createContext<TMembershipContext>(
  {} as TMembershipContext,
);

export const MembershipTypeProvider = (props: TOwnProps) => {
  const [billing, setBilling] = useState<TBillingConfig>({
    startDate: new Date(),
    gracePeriod: 7,
    renewalPeriod: 7,
  });
  const [membershipTypes, setMembershipType] = useState<Array<TMembershipType>>(
    [],
  );

  const [isDirty, setDirty] = useState<boolean>(false);

  return (
    <MembershipTypeContext.Provider
      value={{
        billing,
        setBilling,
        membershipTypes,
        setMembershipType,
        isDirty,
        setDirty,
      }}
    >
      {props.children}
    </MembershipTypeContext.Provider>
  );
};
